import script from "./WidgetFacturesAchat.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetFacturesAchat.vue?vue&type=script&setup=true&lang=js"

import "./WidgetFacturesAchat.vue?vue&type=style&index=0&id=3185238a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3185238a"]])

export default __exports__